import { useOrderEventsContext } from "./order-events-context-provider";
import { useSectionEventTranslations } from "./translations-section-events-context-provider";

function SectionEventsEmpty() {
  const { t } = useSectionEventTranslations();
  const { currentEvents, pastEvents } = useOrderEventsContext();
  const hasEvents = !currentEvents.length && !pastEvents.length;

  return hasEvents ? (
    <div className="flex flex-col">
      <span className="text-prose-lg">{t.noEvents}</span>
    </div>
  ) : null;
}

export { SectionEventsEmpty };
